module.exports = __webpack_public_path__ + "static/media/logo-green.5f9d5d5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-green.svg
// module id = 1238
// module chunks = 0